"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreformattedExtension = void 0;
const core_1 = require("@remirror/core");
let PreformattedExtension = class PreformattedExtension extends core_1.NodeExtension {
    get name() {
        return 'preformatted';
    }
    createTags() {
        return [core_1.ExtensionTag.Block, core_1.ExtensionTag.TextBlock, core_1.ExtensionTag.FormattingNode];
    }
    createNodeSpec(extra, override) {
        return {
            content: 'inline*',
            defining: true,
            draggable: false,
            ...override,
            attrs: {
                ...extra.defaults(),
            },
            parseDOM: [
                {
                    tag: 'pre',
                },
            ],
            toDOM: (node) => {
                return ['pre', extra.dom(node), 0];
            },
        };
    }
    createNodeViews() {
        if (!this.options.enableDecorations) {
            return {};
        }
        return (node) => {
            const { nodeTextAlignment } = node.attrs;
            // This is the pre container for the code block
            const dom = document.createElement('div');
            dom.classList.add(`preformatted`);
            // This is the actual code content in the code block
            const contentDOM = document.createElement('pre');
            contentDOM.setAttribute('data-node-text-align', nodeTextAlignment);
            contentDOM.setAttribute('style', `text-align:${nodeTextAlignment}`);
            // Divider between code block and pre container
            const dividerElement = document.createElement('div');
            dividerElement.classList.add('block-divider');
            // The material icon to use
            const codeIcon = document.createElement('svg');
            codeIcon.classList.add('material-symbols-rounded');
            codeIcon.textContent = 'short_text';
            dom.append(codeIcon);
            dom.append(dividerElement);
            dom.append(contentDOM);
            return { dom, contentDOM };
        };
    }
    /**
     * Toggle the <pre> for the current block.
     */
    togglePreformatted() {
        return (0, core_1.toggleBlockItem)({
            type: this.type,
            toggleType: 'paragraph',
        });
    }
};
__decorate([
    (0, core_1.command)()
], PreformattedExtension.prototype, "togglePreformatted", null);
PreformattedExtension = __decorate([
    (0, core_1.extension)({
        defaultOptions: {
            enableDecorations: false,
        },
    })
], PreformattedExtension);
exports.PreformattedExtension = PreformattedExtension;
